import { useMemo, useState } from "react";

import { TodoItemData } from "./item";
import { groupTodosByDate, TodoGroup } from "./helpers";

export type DateFilter = "all" | "today" | "week" | "absence";
export type TypeFilter = "all" | "CALL" | "MEETING" | "INTERNAL_TASK";
export type PriorityFilter = "all" | "urgent" | "important";

export const useTodoFilters = (todos: TodoItemData[]) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [dateFilter, setDateFilter] = useState<DateFilter>("today");
  const [typeFilter, setTypeFilter] = useState<TypeFilter>("all");
  const [priorityFilter, setPriorityFilter] = useState<PriorityFilter>("all");
  const [archiveFilter, setArchiveFilter] = useState(false);

  // Grupisanje po datumu - backend je već filtrirao podatke
  const groupedTodos: TodoGroup[] = useMemo(() => groupTodosByDate(todos), [todos]);

  return {
    // Filter states
    searchQuery,
    setSearchQuery,
    dateFilter,
    setDateFilter,
    typeFilter,
    setTypeFilter,
    priorityFilter,
    setPriorityFilter,
    archiveFilter,
    setArchiveFilter,
    // Computed values
    groupedTodos,
  };
};
